import { memo } from 'react'
import { IconEyeClose, IconEyeOpen } from '../Icons'
import { styled } from '@mui/material'
import { useMaskedAssets } from 'components/MaskedAssets/hooks'

const Eye = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  line-height: 0;
  svg {
    width: 16px;
    height: 16px;
  }
`
export const AssetsEyes = memo(() => {
  const [maskedAssets, setMaskedAssets] = useMaskedAssets()

  return (
    <Eye>
      {maskedAssets ? (
        <IconEyeClose onClick={() => setMaskedAssets(false)} />
      ) : (
        <IconEyeOpen onClick={() => setMaskedAssets(true)} />
      )}
    </Eye>
  )
})
